import { render, staticRenderFns } from "./CountCollectionTaskDispense.vue?vue&type=template&id=5dfe5908&scoped=true"
import script from "./CountCollectionTaskDispense.vue?vue&type=script&lang=js"
export * from "./CountCollectionTaskDispense.vue?vue&type=script&lang=js"
import style0 from "./CountCollectionTaskDispense.vue?vue&type=style&index=0&id=5dfe5908&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe5908",
  null
  
)

export default component.exports